<template lang="pug">
  router-view
</template>

<script>
  export default {
    beforeCreate () {
      if (this.$ls.get('user').role_id !== '1') this.$router.push({ name: 'Error404' })
    }
  }
</script>



// WEBPACK FOOTER //
// users.vue?f092805e